import { render, staticRenderFns } from "./IconPoiGrocery.vue?vue&type=template&id=26b6e5c3&"
import script from "./IconPoiGrocery.vue?vue&type=script&lang=js&"
export * from "./IconPoiGrocery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports